import { useFlashcardsStore } from "@/stores/flashcardsStore";
import { FlashcardsDeckPickerModal } from "@/components/flashcards/FlashcardsDeckPickerModal";
import ModalShell from "@/components/layout/ModalShell";
import {
  ModalSplitCloseButton,
  SPLIT_MODAL_CLASS_NAME,
} from "@/components/layout/ModalSplitLayout";

/**
 * Single Lernkarten dialog — deck list and study grid share one shell.
 */
export const FlashcardsModal = () => {
  const { view, close } = useFlashcardsStore();

  if (!view) {
    return null;
  }

  return (
    <ModalShell
      onClose={close}
      modalClassName={SPLIT_MODAL_CLASS_NAME}
      labelledBy="lk-deck-picker-title"
    >
      <div className="relative flex h-full min-h-0 flex-1 flex-col overflow-hidden">
        <ModalSplitCloseButton onClose={close} />
        <FlashcardsDeckPickerModal />
      </div>
    </ModalShell>
  );
};
